module.exports = __webpack_public_path__ + "static/jmix-45def24d2513696d794b6a9b5a615910.jpg";